var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-status-component',{attrs:{"itemKey":_vm.itemKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }